if (!customElements.get('announcement-bar-slider')) {
	class AnnouncementBarSlider extends HTMLElement {
		constructor() {
			super();

			this.announcements = this.querySelectorAll('.announcement-slide');
			if (this.announcements.length > 1) {
				this.backgrounds = Array.from(this.querySelectorAll('.announcement-slider-bg'));
				this.changeDelay = 3000;
				this.firstChangeDelay = 1200;
				this.hasAutoAdvanced = false;
				this.currentAnnouncement = 0;
				this.querySelector('.announcement-bar-slider__middle').addEventListener('focusin', this.pauseAnnouncements.bind(this));
				this.querySelector('.announcement-bar-slider__middle').addEventListener('focusout', this.playAnnouncements.bind(this));
				this.querySelector('.announcement-slider-button--previous').addEventListener('click', this.previousAnnouncement.bind(this));
				this.querySelector('.announcement-slider-button--next').addEventListener('click', this.nextAnnouncement.bind(this));
				this.observer = new IntersectionObserver(this.handleIntersect.bind(this));
				this.observer.observe(this);
			}
		}

		handleIntersect(entries) {
			entries.forEach((entry) => {
				if (entry.target === this) {
					if (entry.isIntersecting) {
						this.playAnnouncements();
					} else {
						this.pauseAnnouncements();
					}
				}
			});
		}

		playAnnouncements() {
			if (this.announcements.length > 1) {
				const delay = this.hasAutoAdvanced ? this.changeDelay : this.firstChangeDelay;
				this.announcementTimeout = setTimeout(() => {
					this.hasAutoAdvanced = true;
					this.setCurrentAnnouncement(this.currentAnnouncement + 1);
					this.playAnnouncements();
				}, delay);
			}
		}

		pauseAnnouncements() {
			if (this.announcementTimeout) {
				clearTimeout(this.announcementTimeout);
			}
		}

		setCurrentAnnouncement(newIndex) {
			this.currentAnnouncement = Math.abs(newIndex % this.announcements.length);
			this.announcements.forEach((announcement, index) => {
				const background = this.backgrounds.find((bg) => bg.dataset.index === index.toString());
				if (index !== this.currentAnnouncement) {
					announcement.classList.add('announcement-slide--inactive');
					if (background) {
						background.classList.remove('is-active');
					}
				} else {
					announcement.classList.remove('announcement-slide--inactive');
					if (background) {
						background.classList.add('is-active');
					}
				}
			});

			const headingColor = this.announcements[this.currentAnnouncement].style.getPropertyValue('--heading-color');
			const textColor = this.announcements[this.currentAnnouncement].style.getPropertyValue('--text-color');
			const linkColor = this.announcements[this.currentAnnouncement].style.getPropertyValue('--link-color');
			if (headingColor) {
				this.style.setProperty('--heading-color', headingColor);
			}
			if (textColor) {
				this.style.setProperty('--text-color', textColor);
			}
			if (linkColor) {
				this.style.setProperty('--link-color', linkColor);
			}
		}

		previousAnnouncement() {
			this.setCurrentAnnouncement(this.currentAnnouncement - 1);
		}

		nextAnnouncement() {
			this.setCurrentAnnouncement(this.currentAnnouncement + 1);
		}
	}

	customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
